<div *ngIf="leveledBadge && !error"  class="l-detail-x-subsection wrap textblock automatedcalculation">
    <span class="icon icon-automated"></span>
    <p *ngIf="!error">This application’s automated score is <strong>{{percentage}}%</strong>.</p>
</div>
